<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <page-loader v-if="loadingStatus === 'loading'" />
      <ClassicalNotPurchased v-else-if="!kitPurchased" />
      <section v-else-if="kitPending" class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <KitPendingNotice product="Classical ancestry" />
          </div>
        </div>
      </section>
      <!-- A test being updated to a new version keeps its previous results meanwhile -->
      <ClassicalNotComplete v-else-if="!['completed', 'updating'].includes(kitStatus)" />
      <section class="recent-ancetry-wrapper" v-else>
        <div class="container">
          <div class="row">
            <ClassicalNavigation />
            <router-view v-if="loadingStatus === 'loaded'" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, provide, onMounted } from "vue";
import Header from "@/components/header/Header.vue";
import ClassicalNavigation from "@/view/ancestry/classical/ClassicalNavigation.vue";
import { getClassicalResult, getRequiredContent } from "@/composables/useClassicalContent";
import { useLoading } from "@/composables/useLoading";
import ClassicalNotPurchased from "@/view/ancestry/classical/ClassicalNotPurchased.vue";
import ClassicalNotComplete from "@/view/ancestry/classical/ClassicalNotComplete.vue";
import KitPendingNotice from "@/components/kit/KitPendingNotice.vue";
import { useAncestryKit } from "@/composables/useAncestryKit";
import store from "@/store";

// A kit on its way to results: where it's up to, rather than "available within 48 hours"
const { pending: kitPending } = useAncestryKit();

// Define refs for reactive data
const mapCard = ref({});
const introduction = ref({});
const result = ref({});
const kitPurchased = ref(false);
const kitStatus = ref("");

// Use loading composable for tracking loading state
const { loadingStatus, finishLoading } = useLoading();

onMounted(async () => {
  try {
    // Ensure profile data is available before dispatching
    if (store.getters.profile) {
      await store.dispatch("SET_KIT_TESTS", store.getters.profile.profile.barcode);
    }

    // Set reactive variables for conditional rendering
    kitPurchased.value = store.getters.kitTests.classical.purchased;
    kitStatus.value = store.getters.kitTests.classical.status;

    // Fetch required content and results in parallel
    const [[mapCardRef, introductionRes], resultRes] = await Promise.all([
      getRequiredContent(["classical-map-card", "classical-introduction"]),
      getClassicalResult(),
    ]);

    mapCard.value = mapCardRef;
    introduction.value = introductionRes;
    result.value = resultRes;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    finishLoading();
  }
});

// Provide data to child components
provide("map-card", mapCard);
provide("classical-introduction", introduction);
provide("classical-result", result);
</script>